import api from './api';
import {
  ContentPage,
  QueryContentPagesParams,
  QueryContentPagesResponse,
} from '../types/content';

export const contentService = {
  /**
   * Get content page by slug
   */
  async getBySlug(slug: string): Promise<ContentPage> {
    return api.get(`/content/pages/${slug}`);
  },

  /**
   * Get content page by ID
   */
  async getById(id: string): Promise<ContentPage> {
    return api.get(`/content/pages/id/${id}`);
  },

  /**
   * Query content pages with filters
   */
  async query(params: QueryContentPagesParams = {}): Promise<QueryContentPagesResponse> {
    const queryParams = new URLSearchParams();

    if (params.category) queryParams.append('category', params.category);
    if (params.subcategory) queryParams.append('subcategory', params.subcategory);
    if (params.tags && params.tags.length > 0) {
      params.tags.forEach(tag => queryParams.append('tags', tag));
    }
    if (params.status) queryParams.append('status', params.status);
    if (params.search) queryParams.append('search', params.search);
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());

    const queryString = queryParams.toString();
    return api.get(`/content/pages${queryString ? `?${queryString}` : ''}`);
  },

  /**
   * Get pages by category
   */
  async getByCategory(
    category: string,
    subcategory?: string,
  ): Promise<ContentPage[]> {
    const queryParams = subcategory ? `?subcategory=${subcategory}` : '';
    return api.get(`/content/category/${category}${queryParams}`);
  },

  /**
   * Like a content page
   */
  async like(id: string, source: 'content' | 'article' = 'content'): Promise<{ liked: true; likeCount: number }> {
    return source === 'article'
      ? api.post(`/article-likes/${encodeURIComponent(id)}`)
      : api.post(`/content/pages/${id}/like`);
  },

  async unlike(id: string, source: 'content' | 'article' = 'content'): Promise<{ liked: false; likeCount: number }> {
    return source === 'article'
      ? api.delete(`/article-likes/${encodeURIComponent(id)}`)
      : api.delete(`/content/pages/${id}/like`);
  },

  async getLikeStatus(id: string, source: 'content' | 'article' = 'content'): Promise<{ liked: boolean; likeCount?: number }> {
    return source === 'article'
      ? api.get(`/article-likes/${encodeURIComponent(id)}`)
      : api.get(`/content/pages/${id}/like-status`);
  },
};
